import React, {useState} from 'react';
import './App.css';

import { Greet } from './components/Greet';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { motion, Variants } from "framer-motion";

const App: React.FC = () => (
	<BrowserRouter>
		<Routes>
			<Route path="/" element={<Root />} />
			{/* <Route path="users/:id" element={<Users />} /> */}
		</Routes>
	</BrowserRouter>
);

// function App() {
//   return (
//     <div className="App">
//       <Greet name='Jojo' />
//     </div>
//   );
// }

const itemVariants: Variants = {
	open: {
	  opacity: 1,
	  y: 0,
	  transition: { type: "spring", stiffness: 300, damping: 24 }
	},
	closed: { opacity: 0, y: 20, transition: { duration: 0.2 } }
  };

const Root = () => {

	const [isOpen, setIsOpen] = useState(false);
	return (
		<>
		{/* <header className="bg-white border border-yellow-300 hidden md:flex fixed top-0 w-full shadow-md">
        <motion.nav className="container mx-auto px-6 py-3" initial={false} animate={isOpen ? "open" : "closed" }>
            <div className="flex justify-between items-center">
                <a href="/a" className="text-2xl font-bold text-gray-800">JonathanJordan21</a>
                <div className="hidden md:flex items-end space-x-4">
                    <a href="/" className="text-gray-800 hover:text-blue-600">Home</a>
                    <a href="/a" className="text-gray-800 hover:text-blue-600">About</a>
                    <a href="/projects" className="text-gray-800 hover:text-blue-600">Projects</a>
                    <a href="https://github.com" className="text-gray-800 hover:text-blue-600">Contact</a>
                </div>
                <motion.div className="md:hidden flex items-center">
                    <motion.button className="text-gray-800 focus:outline-none" whileTap={{scale: 0.97}} onClick={()=> setIsOpen(!isOpen)}>
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
                        </svg>
                    </motion.button>

					<motion.ul variants={{
						open: {
							clipPath: "inset(0% 0% 0% 0% round 10px)",
							transition: {
							type: "spring",
							bounce: 0,
							duration: 0.7,
							delayChildren: 0.3,
							staggerChildren: 0.05
							}
						},
						closed: {
							clipPath: "inset(10% 50% 90% 50% round 10px)",
							transition: {
							type: "spring",
							bounce: 0,
							duration: 0.3
							}
						}
						}}
						style={{ pointerEvents: isOpen ? "auto" : "none" }}
					>
						<motion.li variants={itemVariants}>Item 1 </motion.li>
						<motion.li variants={itemVariants}>Item 2 </motion.li>
						<motion.li variants={itemVariants}>Item 3 </motion.li>
						<motion.li variants={itemVariants}>Item 4 </motion.li>
						<motion.li variants={itemVariants}>Item 5 </motion.li>
					</motion.ul>
                </motion.div>
            </div>
        </motion.nav>
    </header> */}
	<Greet name='jojo' />
	</>
	)
}

export default App;
